import { html, LitElement } from "lit-element";
import { classMap } from "lit-html/directives/class-map";
import { paths } from "../resources";
/**
 * Show the "please wait" message when video stopped because of not loaded
 */
export class Video360LoadingPaused extends LitElement {
    constructor() {
        super(...arguments);
        this.show = false;
    }
    static get properties() {
        return {
            show: { type: Boolean },
        };
    }
    createRenderRoot() {
        return this;
    }
    render() {
        const klass = {
            dn: !this.show,
        };
        return html `<img
      class="absolute ${classMap(klass)}"
      src=${paths.video360VideoLoadingPaused}
    />`;
    }
}
customElements.define("jh-360-video-loading-paused", Video360LoadingPaused);
//# sourceMappingURL=loadingPaused.js.map